<template>
  <section>
    <close-button @click="$emit('close')" class="close-button"></close-button>
    <div class="dialog-header">
      <h1>Advertentie producten</h1>
    </div>
    <ul class="simple-list-container">
      <li v-for="(product, index) in products" :key="index" class="product">
        <div
          class="thumb"
          :style="{
            backgroundImage: 'url(' + imageUrl(product.previewImage) + ')'
          }"
        ></div>

        <div class="title">
          {{ product.name }}
        </div>
        <remove-button
          class="remove-file"
          @remove="remove(product)"
        ></remove-button>
      </li>
    </ul>
  </section>
</template>

<script>
import {
  updateProduct,
  getRandomPrintStoreProducts
} from '@/features/printstore/PrintStoreApi'
import RemoveButton from '@/components/ui/RemoveButton.vue'
import { orderBy } from 'lodash-es/collection'

export default {
  //  props: ['products'],
  data() {
    return {
      products: []
    }
  },
  components: {
    RemoveButton
  },
  methods: {
    imageUrl(id) {
      return `/media/print-store/${this.rootStore.user.printStore.id}/preview/${id}/66`
    },
    async remove(product) {
      await updateProduct({
        id: product.id,
        name: product.name,
        description: product.description,
        productTypeId: product.productTypeId,
        previewImage: product.previewImage,
        designer: product.designer,
        availableForAd: false,
        displaySpecification: product.displaySpecification || {}
      })

      getRandomPrintStoreProducts().then((resp) => {
        this.products = resp
      })
    }
  },
  mounted() {
    getRandomPrintStoreProducts().then((resp) => {
      const nameSorter = (prod) => prod.name.toLowerCase()
      this.products = orderBy(resp, [nameSorter])
    })
  }
}
</script>

<style lang="scss" scoped>
.simple-list-container {
  padding: 25px;
  background-color: white;
  //box-shadow: rgba(0, 0, 0, 0.4) 0 20px 60px -2px;
  border-radius: 5px;
  //max-height: 600px;
  overflow-y: auto;
}
.product {
  display: flex;
  margin-bottom: 7px;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
}
.thumb {
  width: 33px;
  height: 33px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-right: 7px;
  flex-shrink: 0;
  flex-grow: 0;
  //border-radius: 70px;
  //border: 1px solid #efefef;
}

.title {
  flex-grow: 1;
  background-color: #f4f4f4;
  border-radius: 20px;
  height: 34px;
  line-height: 33px;
  font-weight: 500;
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
</style>
